import { Injectable } from '@angular/core';
import { SocieteCaracteristique, SocieteCaracteristiqueToHandle } from '@get/api-interfaces';
import { SocieteCaracteristiqueActions, SocieteCaracteristiqueGeneratedActions } from '@get/store/actions';
import { AppState } from '@get/store/configs/reducers';
import { SocieteCaracteristiqueSelectors } from '@get/store/selectors';
import { SelectSchema, catchApiActions } from '@get/utils';
import { Actions } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { Observable, mapTo, switchMap } from 'rxjs';
import { GeneratedSocieteCaracteristiqueService } from './societe-caracteristique-generated.service';

@Injectable({
  providedIn: 'root'
})
export class SocieteCaracteristiqueService extends GeneratedSocieteCaracteristiqueService {
  constructor(store$: Store<AppState>, actions$: Actions) {
    super(store$, actions$);
  }

  public selectAllSocieteCaracteristiquePatrimoines(schema: SelectSchema = {}): Observable<SocieteCaracteristique[]> {
    return this.store$
      .pipe(select(SocieteCaracteristiqueSelectors.selectAllSocieteCaracteristiquePatrimoines(schema)))
      .pipe(
        switchMap(({ societeCaracteristiques }: { societeCaracteristiques: SocieteCaracteristique[] }) => {
          return this.getReady(schema).pipe(mapTo(societeCaracteristiques));
        })
      );
  }

  public selectAllSocieteCaracteristiqueComposants(schema: SelectSchema = {}): Observable<SocieteCaracteristique[]> {
    return this.store$
      .pipe(select(SocieteCaracteristiqueSelectors.selectAllSocieteCaracteristiqueComposants(schema)))
      .pipe(
        switchMap(({ societeCaracteristiques }: { societeCaracteristiques: SocieteCaracteristique[] }) => {
          return this.getReady(schema).pipe(mapTo(societeCaracteristiques));
        })
      );
  }

  public handleManySocieteCaracteristiques(
    params: SocieteCaracteristiqueToHandle
  ): void | Observable<SocieteCaracteristique[]> {
    this.store$.dispatch(SocieteCaracteristiqueActions.handleManySocieteCaracteristiques(params));
  }
}
